export default {"src":"/_next/static/media/EU.856efb34.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};